module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign_closeButton_8bde9f9b85c83ae6352c6e880abb2fbc.png";